import React from "react";
import { observer } from "mobx-react";
import { AiSearchResponseCreateStore } from "../../store";
import { AiSearchResponseCreateForm } from "./AiSearchResponseCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { EvaluationRating } from "../../../../api/graphql";

export type AiSearchResponseCreateProps = {
  aiSearchResponseCreateStore: AiSearchResponseCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AiSearchResponseCreate: React.FC<AiSearchResponseCreateProps> =
  observer(
    ({ aiSearchResponseCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={aiSearchResponseCreateStore.isSaving} />
          <AiSearchResponseCreateForm
            aiSearchResponseCreateStore={aiSearchResponseCreateStore}
            conversationError={
              aiSearchResponseCreateStore.errors.conversation?.message
            }
            onConversationChange={(value) => {
              aiSearchResponseCreateStore.setConversationValue(value);
            }}
            conversationSelectedValue={
              aiSearchResponseCreateStore.entityValues.showConversation
            }
            onConversationSelected={(value) => {
              aiSearchResponseCreateStore.setSelectedConversation(value);
            }}
            conversationOptions={aiSearchResponseCreateStore.getConversationOptions()}
            queryError={aiSearchResponseCreateStore.errors.query?.message}
            onQueryChange={(value: string) => {
              aiSearchResponseCreateStore.setQueryValue(value);
            }}
            query={aiSearchResponseCreateStore.entityValues.query}
            responseError={aiSearchResponseCreateStore.errors.response?.message}
            onResponseChange={(value: string) => {
              aiSearchResponseCreateStore.setResponseValue(value);
            }}
            response={aiSearchResponseCreateStore.entityValues.response}
            sourcesError={aiSearchResponseCreateStore.errors.sources?.message}
            onSourcesChange={(value: string) => {
              aiSearchResponseCreateStore.setSourcesValue(value);
            }}
            sources={aiSearchResponseCreateStore.entityValues.sources}
            explanationError={
              aiSearchResponseCreateStore.errors.explanation?.message
            }
            onExplanationChange={(value: string) => {
              aiSearchResponseCreateStore.setExplanationValue(value);
            }}
            explanation={aiSearchResponseCreateStore.entityValues.explanation}
            tokenUsageError={
              aiSearchResponseCreateStore.errors.tokenUsage?.message
            }
            onTokenUsageChange={(value: string) => {
              aiSearchResponseCreateStore.setTokenUsageValue(value);
            }}
            tokenUsage={aiSearchResponseCreateStore.entityValues.tokenUsage}
            ratingError={aiSearchResponseCreateStore.errors.rating?.message}
            ratingOptions={aiSearchResponseCreateStore.getRatingOptions()}
            onRatingChange={(value: EvaluationRating | "") => {
              aiSearchResponseCreateStore.setRatingValue(value);
            }}
            rating={aiSearchResponseCreateStore.entityValues.rating}
            evaluatedAtError={
              aiSearchResponseCreateStore.errors.evaluatedAt?.message
            }
            onEvaluatedAtChange={(value) => {
              aiSearchResponseCreateStore.setEvaluatedAtValue(value);
            }}
            evaluatedAt={aiSearchResponseCreateStore.entityValues.evaluatedAt}
            evaluatedByError={
              aiSearchResponseCreateStore.errors.evaluatedBy?.message
            }
            onEvaluatedByChange={(value) => {
              aiSearchResponseCreateStore.setEvaluatedByValue(value);
            }}
            evaluatedBySelectedValue={
              aiSearchResponseCreateStore.entityValues.showEvaluatedBy
            }
            onEvaluatedBySelected={(value) => {
              aiSearchResponseCreateStore.setSelectedEvaluatedBy(value);
            }}
            evaluatedByOptions={aiSearchResponseCreateStore.getEvaluatedByOptions()}
            aiSearchToolCallCreateStore={
              aiSearchResponseCreateStore.toolCallsCreateStore
            }
            toolCallsVisibleColumns={
              aiSearchResponseCreateStore.toolCallsVisibleColumns
            }
            toolCallsOnRestore={(id: string) =>
              aiSearchResponseCreateStore.toolCallsRestore(id)
            }
            toolCallsOnCommitChanges={(changes) =>
              aiSearchResponseCreateStore.toolCallsCommitChanges(changes)
            }
            toolCallsValidateChanges={(changes) =>
              aiSearchResponseCreateStore.toolCallsValidateChanges(changes)
            }
            toolCallsRows={
              aiSearchResponseCreateStore.entityValues.showToolCalls
            }
            toolCallsError={
              aiSearchResponseCreateStore.errors.toolCalls?.message
            }
            dummyCRUDRestoredObservable={
              aiSearchResponseCreateStore.dummyCRUDRestoredObservable
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={aiSearchResponseCreateStore.isProcessing}
            onSave={() => aiSearchResponseCreateStore.saveNewAiSearchResponse()}
            onCancel={() =>
              aiSearchResponseCreateStore.cancelNewAiSearchResponse()
            }
          />
          <ErrorDialog
            open={aiSearchResponseCreateStore.errorDialogOpened}
            title={aiSearchResponseCreateStore.errorTitle}
            description={aiSearchResponseCreateStore.errorDescription}
            onClose={() => aiSearchResponseCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
